/* =========================================================
   EAZY CLOTHES — KATALOG
   Etap 3. Dwa moduly, kazdy jako nazwana funkcja IIFE.

   Bez localStorage/sessionStorage, zgodnie z zalozeniami projektu.
   Wybrany widok nie jest wiec pamietany miedzy wejsciami na sklep —
   ale przezywa przeladowania w obrebie katalogu (filtr, paginacja,
   odswiezenie, "wstecz"), bo jedzie w adresie jako ez_view.
   ========================================================= */

/* ---------------------------------------------------------
   MODUL: przelacznik widokow INDEX / GRID
   Oba widoki sa w DOM; przelaczamy klase na kontenerze.
   --------------------------------------------------------- */
(function ezCatalogViewToggle() {
  /* Przyciski siedza w pasku sterowania, a klase widoku czyta kontener
     listy — to dwa rozne elementy, wiec sekcja jest tu punktem wyjscia,
     a kontener wyszukiwany osobno. Wczesniej klasa ladowala na sekcji,
     przez co CSS (.ez-cat__container.is-grid-view) nigdy jej nie widzial:
     przyciski zmienialy swoj stan, ale uklad zostawal bez zmian. */
  /* Nazwa parametru NIE moze brzmiec 'view': Shopify rezerwuje to slowo
     na alternatywne szablony (?view=nazwa renderuje collection.nazwa.liquid),
     wiec przelacznik widoku probowalby wyrenderowac nieistniejacy szablon. */
  const VIEW_PARAM = 'ez_view';

  const init = (section) => {
    const container = section.querySelector('[data-catalog-container]');
    const buttons = Array.from(section.querySelectorAll('[data-catalog-view]'));
    if (!container || buttons.length === 0) return;

    /* Widok domyslny przychodzi z Liquida, z ustawienia sekcji. Dzieki temu
       ani ta funkcja, ani syncAddressBar nie musza wiedziec, KTORY z dwoch
       widokow jest akurat domyslny — i nie trzeba ich ruszac, gdyby to sie
       kiedys znowu zmienilo. */
    const defaultView = container.dataset.catalogDefaultView === 'grid' ? 'grid' : 'index';

    /* Pigulki kategorii i paginacja to zwykle odnosniki — kazde klikniecie
       to pelne przeladowanie strony, a wybrany widok zyje wylacznie jako
       klasa na kontenerze. Bez tego wracalo sie za kazdym razem do widoku
       z ustawien sekcji. Dopisujemy wiec widok do ich adresow. */
    const linksToKeepView = () => Array.from(section.querySelectorAll('[data-catalog-keep-view]'));

    const syncLinks = (view) => {
      linksToKeepView().forEach((link) => {
        const url = new URL(link.getAttribute('href'), window.location.href);
        if (view === defaultView) {
          url.searchParams.delete(VIEW_PARAM);
        } else {
          url.searchParams.set(VIEW_PARAM, view);
        }
        link.setAttribute('href', `${url.pathname}${url.search}`);
      });
    };

    /* Adres biezacej strony tez dostaje widok, zeby przetrwal odswiezenie
       i powrot przyciskiem "wstecz". replaceState, a nie pushState —
       przelaczenie widoku nie ma byc osobnym wpisem w historii. */
    /* Parametr znika z adresu wtedy, gdy wybrany widok POKRYWA SIE
       z domyslnym z ustawien sekcji, a nie wtedy, gdy jest nim akurat
       index. Wczesniej bylo na sztywno: grid ustawial parametr, index go
       kasowal. Dzialalo, dopoki domyslny byl index — po przestawieniu
       domyslnego na grid przelaczenie na index kasowaloby parametr, adres
       zostawalby czysty i odswiezenie wracaloby do grida, gubiac wybor
       klienta. Skrypt wejsciowy w sekcji czytal oba kierunki
       (ez_view=grid i ez_view=index) juz wczesniej, wiec strona odbiorcza
       byla gotowa — brakowalo tylko symetrii po stronie zapisu. */
    const syncAddressBar = (view) => {
      const url = new URL(window.location.href);
      if (view === defaultView) {
        url.searchParams.delete(VIEW_PARAM);
      } else {
        url.searchParams.set(VIEW_PARAM, view);
      }
      window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    };

    const setView = (view, updateAddressBar = true) => {
      container.classList.toggle('is-grid-view', view === 'grid');
      buttons.forEach((button) => {
        const selected = button.dataset.catalogView === view;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      syncLinks(view);
      if (updateAddressBar) syncAddressBar(view);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => setView(button.dataset.catalogView));
    });

    /* Stan wejsciowy: klase widoku nadal juz skrypt w tresci sekcji (robi to
       przed pierwszym malowaniem, zeby nie mrugnac lista przed siatka).
       Tutaj tylko dociagamy do niego przyciski i odnosniki. Pasek adresu
       zostaje nietkniety — jest zrodlem tej informacji, nie jej odbiorca. */
    setView(container.classList.contains('is-grid-view') ? 'grid' : 'index', false);
  };

  const initAll = (scope) => {
    scope.querySelectorAll('.ez-cat').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

/* ---------------------------------------------------------
   MODUL: dynamiczny podglad w widoku INDEX

   Prototyp mapowal wiersz na obrazek CSS-owym :has() z szescioma
   zahardkodowanymi parami data-hover. Tutaj jest jeden element podgladu,
   ktoremu podmieniamy zrodlo z atrybutu najechanego wiersza — dziala
   dla dowolnej liczby produktow i nie rosnie razem z katalogiem.

   Podglad reaguje tez na fokus z klawiatury, nie tylko na kursor.
   --------------------------------------------------------- */
(function ezCatalogPreview() {
  const SWAP_DELAY = 140;

  const init = (container) => {
    const preview = container.querySelector('[data-catalog-preview]');
    const rows = Array.from(container.querySelectorAll('[data-catalog-row]'));
    if (!preview || rows.length === 0) return;

    const image = preview.querySelector('[data-catalog-preview-img]');
    const refEl = preview.querySelector('[data-catalog-preview-ref]');
    const nameEl = preview.querySelector('[data-catalog-preview-name]');
    const priceEl = preview.querySelector('[data-catalog-preview-price]');

    let swapTimer = null;
    let currentSrc = null;

    /* Podglad ma sens tylko obok listy: w siatce jest ukryty, na dotyku
       nie ma czym najechac, a ponizej 1000px nie ma dla niego miejsca
       (wyliczenie stoi przy @media w eazy-collection.liquid — prog musi
       byc w obu miejscach ten sam). */
    const isAvailable = () =>
      !container.classList.contains('is-grid-view') && window.matchMedia('(min-width: 1000px)').matches;

    const show = (row) => {
      if (!isAvailable()) return;

      const src = row.dataset.previewSrc;
      if (!src || src === currentSrc) {
        preview.classList.add('is-showing');
        return;
      }

      window.clearTimeout(swapTimer);
      preview.classList.remove('is-showing');

      swapTimer = window.setTimeout(() => {
        currentSrc = src;
        if (image) {
          /* srcset MUSI isc razem ze src. Gdy jest ustawiony, przegladarka
             wybiera zrodlo z niego i ignoruje src — podmiana samego src
             zostawilaby na ekranie poprzedni produkt. */
          image.srcset = row.dataset.previewSrcset || '';
          image.src = src;
          image.alt = '';
        }
        if (refEl) refEl.textContent = row.dataset.previewRef || '';
        if (nameEl) nameEl.textContent = row.dataset.previewName || '';
        if (priceEl) priceEl.textContent = row.dataset.previewPrice || '';
        preview.classList.add('is-showing');
      }, SWAP_DELAY);
    };

    const hide = () => {
      window.clearTimeout(swapTimer);
      preview.classList.remove('is-showing');
    };

    rows.forEach((row) => {
      row.addEventListener('mouseenter', () => show(row));
      row.addEventListener('mouseleave', hide);
      row.addEventListener('focus', () => show(row));
      row.addEventListener('blur', hide);
    });

    container.addEventListener('mouseleave', hide);
  };

  const initAll = (scope) => {
    scope.querySelectorAll('[data-catalog-container]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
